export const Svg_128 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M34.927 61.25 13.782 49.656v-17.5L2.917 26.25l32.01-17.5 32.157 17.5v23.115h-4.376V28.802l-6.635 3.354v17.5L34.927 61.25Zm0-22.458L57.896 26.25 34.927 13.927 12.104 26.25l22.823 12.542Zm0 17.5 16.771-9.26v-12.25l-16.77 8.968-16.771-9.115v12.396l16.77 9.26Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={17.755}
        x2={40.21}
        y1={16.625}
        y2={61.041}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)